import EmailPassword from "supertokens-auth-react/recipe/emailpassword"
import Session from "supertokens-auth-react/recipe/session";
import SuperTokens, { SuperTokensWrapper } from "supertokens-auth-react";
import ThirdPartyEmailPassword, { Github, Google, Apple, Twitter } from "supertokens-auth-react/recipe/thirdpartyemailpassword";
import Passwordless from "supertokens-auth-react/recipe/passwordless";


// import { TypeInput } from "supertokens-node/types";
// import getSuperTokensRoutesForReactRouterDom from 'supertokens-auth-react';
import * as reactRouterDom from "react-router-dom";
import AppConfig from "../utility/AppConfig";

function isLocalhost() {
  return window.location.hostname === 'localhost';
}


export const SuperTokenConfig:any =  {

        appInfo: {
          // learn more about this on https://supertokens.com/docs/emailpassword/appinfo
          appName: 'react_exp',
          apiDomain: isLocalhost() ? `http://localhost:3000` : AppConfig.DASHBOARD_V2_API_URL,
          websiteDomain: isLocalhost() ? `http://localhost:3000` : AppConfig.DASHBOARD_V2_WEBSITE_DOMAIN,
          apiBasePath: '/auth',
          websiteBasePath: '/Dashboard/auth',
        },
        recipeList: [
           EmailPassword.init(),
           Session.init(),
           Passwordless.init({
            contactMethod: "EMAIL",
            signInUpFeature: {
                // The default value is 15 seconds
                resendEmailOrSMSGapInSeconds: 60,
            }
           }),
            //EmailPassword.init(), // initializes signin / sign up features,
            ThirdPartyEmailPassword.init()
            // ThirdPartyEmailPassword.init({/*TODO: See next step*/}),
        ],
}
// const signUpData = {
//   formFields: [
//     { id: 'email', value: 'admin@nanoheal.com' },
//     { id: 'password', value: 'nanoheal@123' }
//   ]
// };

// fetch(`${AppConfig.DASHBOARD_V2_API_URL}/auth/signup`, {
//   method: 'POST',
//   headers: {
//     'Content-Type': 'application/json',
//   },
//   body: JSON.stringify(signUpData),
// })
//   .then(response => response.json())
//   .then(data => {
//     'response data here'
//     console.log(data);
//   })
//   .catch(error => {
//     // Handle errors
//     console.error('Error:', error);
//   });